import { type Api } from "api-client";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "ui";
import {
  Button,
  type ButtonVariant,
  Dialog,
  DialogContent,
  DialogTrigger,
  type ButtonSize,
} from "ui";

import { AssignEmailToAthleteDialogContent } from "src/components/AssignEmailToAthleteDialogContent";
export { AssignEmailToAthleteDialogContent };
export { formSchema } from "src/invitations/AssignEmailToAthleteDialog.shared";
export type {
  AssignEmailToAthleteDialogContentProps,
  FormSchema,
} from "src/invitations/AssignEmailToAthleteDialog.shared";

export interface InviteAthleteDialogProps {
  athleteId: string;
  refresh?: () => void;
  buttonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  buttonClassName?: string;
  onInviteSuccess?: (arg: Api.InviteAthlete.Output.Self) => void;
  showTrigger?: boolean;
  open?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
}

export function AssignEmailToAthleteDialog(props: InviteAthleteDialogProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const showTrigger = props.showTrigger ?? true;
  const { t } = useTranslation();

  const open = props.open ?? isOpen;
  const onOpenChange = props.onOpenChange ?? setIsOpen;

  return (
    <div
      className="flex"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Dialog open={open} onOpenChange={onOpenChange} modal>
        {showTrigger && (
          <DialogTrigger asChild type="button">
            <Button
              className={cn(props.buttonClassName)}
              size={props.buttonSize || "sm"}
              variant={props.buttonVariant || "outline"}
            >
              <div>{t("assignEmail")}</div>
            </Button>
          </DialogTrigger>
        )}
        <DialogContent className="sm:max-w-[425px]">
          {open && (
            <AssignEmailToAthleteDialogContent
              athleteId={props.athleteId}
              closeModal={() => {
                onOpenChange(false);
                props.refresh?.();
              }}
              onInviteSuccess={props.onInviteSuccess}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
